import { isAxiosError } from "axios"

export type RobinVoiceTranscriptionErrorCode =
  | "no-speech"
  | "too-large"
  | "not-authenticated"
  | "timeout"
  | "network"
  | "transcription-failed"

/**
 * Converts generated-client and backend failures into the composer-level voice
 * states Robin can explain. Transport/status details stay in `api`, while the
 * recorder hook only decides whether transcription succeeded or failed.
 */
export function robinVoiceTranscriptionErrorCode(
  error: unknown,
): RobinVoiceTranscriptionErrorCode {
  if (!isAxiosError(error)) return "transcription-failed"

  if (error.code === "ECONNABORTED" || error.code === "ETIMEDOUT") {
    return "timeout"
  }

  if (!error.response) return "network"

  switch (error.response.status) {
    case 401:
      return "not-authenticated"
    case 413:
      return "too-large"
    case 422:
      return "no-speech"
    default:
      return "transcription-failed"
  }
}
